

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 11 13"}, rest), [h('path', {"fill":"currentColor","fill-rule":"evenodd","d":"m4.897.001 4.485.001C10.276.002 11 .752 11 1.68v1.343c0 .64-.37 1.367-.718 1.727L7.735 7.087c-.247.214-.44.683-.44 1.062v2.624c0 .543-.33 1.171-.742 1.428l-.812.543c-.265.17-.565.256-.865.256a1.657 1.657 0 0 1-1.647-1.672V8.094c0-.305-.194-.763-.376-.995l-2.2-2.416C.283 4.298 0 3.639 0 3.145V1.74C0 .765.712.002 1.618.002L4.843.001a.42.42 0 0 1 .054 0Zm4.491.917L5.108.917 2.457 5.324l1.067 1.165c.3.384.594 1.025.594 1.599v3.234c0 .397.264.592.376.653.247.14.547.14.777-.006l.817-.543c.165-.104.33-.434.33-.653V8.149c0-.653.306-1.373.747-1.758L9.682 4.08c.2-.208.442-.702.442-1.062V1.68a.75.75 0 0 0-.736-.762ZM4.071.917H1.618c-.412 0-.736.36-.736.824v1.404c0 .226.177.665.4.897l.549.598L4.071.917Z"}, [])]);
};

        